export const orderPinnedByColumnOrder = (columnOrder, pinnedColumns) => {
  const pinnedSet = new Set(pinnedColumns);
  return columnOrder.filter((col) => pinnedSet.has(col));
};

export const getColumnOrderDiff = (saved, current) => {
  const savedPositions = new Map(saved.map((col, idx) => [col, idx]));
  const currentPositions = new Map(current.map((col, idx) => [col, idx]));

  const savedWithStatus = saved.map((col) => {
    const savedPos = savedPositions.get(col);
    const currentPos = currentPositions.get(col);
    const removed = currentPos === undefined;
    const moved =
      !removed &&
      savedPos !== undefined &&
      currentPos !== undefined &&
      savedPos !== currentPos;
    return { col, moved, removed };
  });

  const currentWithStatus = current.map((col) => {
    const savedPos = savedPositions.get(col);
    const currentPos = currentPositions.get(col);
    const added = savedPos === undefined;
    const moved =
      !added &&
      savedPos !== undefined &&
      currentPos !== undefined &&
      savedPos !== currentPos;
    return { col, moved, added };
  });

  return { saved: savedWithStatus, current: currentWithStatus };
};
